namespace TabAurous.Production {
    export interface MFGTransactionItemsRow {
        TransItemId?: number;
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        OrderTypeId?: number;
        OrderTransId?: number;
        OrderTransItemId?: number;
        ProductId?: number;
        ProductCode?: string;
        AttributeId?: number;
        Attribute?: string;
        BagNo?: string;
        SubBagNo?: number;
        LotNo?: string;
        Line_No?: number;
        Parts?: number;
        FromPieces?: number;
        FromWeight?: number;
        FromNetWeight?: number;
        FromDiamondPieces?: number;
        FromDiamondWeight?: number;
        FromStonePieces?: number;
        FromStoneWeight?: number;
        FromOtherPieces?: number;
        FromOtherWeight?: number;
        ToPieces?: number;
        ToWeight?: number;
        ToNetWeight?: number;
        ToDiamondPieces?: number;
        ToDiamondWeight?: number;
        ToStonePieces?: number;
        ToStoneWeight?: number;
        ToOtherPieces?: number;
        ToOtherWeight?: number;
        Purity?: number;
        PureWeight?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        FromDeptId?: number;
        ToDeptId?: number;
        FromWorkerId?: number;
        ToWorkerId?: number;
        FromProcessId?: number;
        ToProcessId?: number;
        LossPercent?: number;
        Loss?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        StockAllocation?: boolean;
        StartDateTime?: string;
        EndDateTime?: string;
        DepartmentId?: number;
        ImageName?: string;
        BOMDetails?: MFGTransactionBOMRow[];
        LossDetails?: MFGTransactionLossRow[];
        QualityInspection?: MFGInspectionValuesRow[];
        TreeId?: number;
        TreeItemId?: number;
        TreeNo?: string;
        QualityInspectionValue?: boolean;
        Button?: string;
        ProductItemImage?: string;
        MetalId?: number;
        KaratId?: number;
        MetalColorId?: number;
    }

    export namespace MFGTransactionItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.MFGTransactionItems';
        export const deletePermission = 'Production:MFGTransaction:Delete';
        export const insertPermission = 'Production:MFGTransaction:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:MFGTransaction:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            OrderTypeId = "OrderTypeId",
            OrderTransId = "OrderTransId",
            OrderTransItemId = "OrderTransItemId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Parts = "Parts",
            FromPieces = "FromPieces",
            FromWeight = "FromWeight",
            FromNetWeight = "FromNetWeight",
            FromDiamondPieces = "FromDiamondPieces",
            FromDiamondWeight = "FromDiamondWeight",
            FromStonePieces = "FromStonePieces",
            FromStoneWeight = "FromStoneWeight",
            FromOtherPieces = "FromOtherPieces",
            FromOtherWeight = "FromOtherWeight",
            ToPieces = "ToPieces",
            ToWeight = "ToWeight",
            ToNetWeight = "ToNetWeight",
            ToDiamondPieces = "ToDiamondPieces",
            ToDiamondWeight = "ToDiamondWeight",
            ToStonePieces = "ToStonePieces",
            ToStoneWeight = "ToStoneWeight",
            ToOtherPieces = "ToOtherPieces",
            ToOtherWeight = "ToOtherWeight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            FromDeptId = "FromDeptId",
            ToDeptId = "ToDeptId",
            FromWorkerId = "FromWorkerId",
            ToWorkerId = "ToWorkerId",
            FromProcessId = "FromProcessId",
            ToProcessId = "ToProcessId",
            LossPercent = "LossPercent",
            Loss = "Loss",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            StockAllocation = "StockAllocation",
            StartDateTime = "StartDateTime",
            EndDateTime = "EndDateTime",
            DepartmentId = "DepartmentId",
            ImageName = "ImageName",
            BOMDetails = "BOMDetails",
            LossDetails = "LossDetails",
            QualityInspection = "QualityInspection",
            TreeId = "TreeId",
            TreeItemId = "TreeItemId",
            TreeNo = "TreeNo",
            QualityInspectionValue = "QualityInspectionValue",
            Button = "Button",
            ProductItemImage = "ProductItemImage",
            MetalId = "MetalId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId"
        }
    }
}
